import { SignedIn, SignedOut, SignInButton } from "@clerk/clerk-react";
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function FinalCTA() {
  const { t } = useTranslation();
  return (
    <section className="cta-final">
      <h2>{t('landing.final.line1', { defaultValue: 'Stop struggling with captions.' })}<br/><em>{t('landing.final.line2', { defaultValue: 'Start creating in seconds.' })}</em></h2>
      <p>{t('landing.final.sub', { defaultValue: 'Join creators who write better Instagram copy in a fraction of the time. Free to start, no card required.' })}</p>
      <div className="hero-ctas">
        <SignedOut>
          <SignInButton mode="modal">
            <button className="btn-primary" type="button">{t('landing.cta.start', { defaultValue: 'Try Free — No Card Required' })}</button>
          </SignInButton>
        </SignedOut>
        <SignedIn>
          <Link to="/dashboard" className="btn-primary">{t('landing.cta.dashboard', { defaultValue: 'Go to Dashboard' })}</Link>
        </SignedIn>
      </div>
      <p style={{ fontSize: '0.8rem', color: 'var(--muted)', marginTop: '15px', opacity: '0.8' }}>
        {t('landing.final.micro', { defaultValue: 'Free forever plan available. No credit card required.' })}
      </p>
    </section>
  );
}
